import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 3264.000000 3264.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,3264.000000) scale(0.100000,-0.100000)" >
<path d="M16023 22179 c-95 -4 -203 -12 -240 -18 -37 -5 -93 -13 -123 -16
-517 -59 -1149 -293 -1608 -597 -368 -244 -646 -488 -900 -793 -649 -777 -975
-1742 -930 -2752 64 -1441 902 -2737 2188 -3382 237 -119 508 -227 695 -276
242 -65 403 -98 645 -132 100 -14 193 -18 470 -17 365 0 468 9 760 65 770 150
1463 513 2028 1064 335 325 577 657 786 1075 254 507 383 995 417 1578 32 543
-58 1115 -259 1642 -203 532 -511 1000 -934 1417 -166 163 -220 210 -383 333
-429 321 -820 516 -1330 665 -170 49 -360 87 -605 120 -103 14 -165 18 -430
28 -41 2 -152 0 -247 -4z m638 -234 c509 -48 963 -176 1401 -396 600 -301
1156 -808 1518 -1384 601 -955 748 -2162 396 -3230 -113 -342 -274 -667 -478
-970 -166 -245 -426 -538 -648 -730 -629 -542 -1380 -858 -2210 -930 -698 -60
-1418 83 -2060 410 -899 459 -1577 1253 -1895 2220 -276 838 -254 1736 63
2565 286 747 791 1374 1472 1827 212 142 364 223 615 330 559 240 1223 344
1826 288z"/>
<path d="M16058 20773 c-16 -2 -28 -8 -28 -13 0 -10 104 -1 135 11 21 8 -56
10 -107 2z"/>
<path d="M15883 20753 c-18 -7 -16 -23 2 -23 8 0 15 7 15 15 0 8 -1 15 -2 14
-2 0 -9 -3 -15 -6z"/>
<path d="M16592 20712 c-17 -12 30 -22 100 -22 27 0 57 -4 66 -8 9 -4 37 -5
62 -2 55 8 37 17 -50 24 -36 3 -87 8 -115 11 -27 3 -56 2 -63 -3z"/>
<path d="M16065 20700 c-18 -8 -17 -9 8 -9 16 -1 26 3 22 9 -3 6 -7 10 -8 9
-1 0 -11 -4 -22 -9z"/>
<path d="M16465 20696 c-18 -13 -17 -14 9 -28 l29 -15 -48 -6 c-26 -4 -51 -5
-55 -2 -11 7 -191 27 -252 29 -60 1 -68 -18 -10 -22 23 -2 42 -7 42 -13 0 -12
13 -11 -160 -18 -94 -4 -153 -10 -150 -16 3 -5 -8 -13 -25 -17 -91 -22 -129
-36 -140 -52 -15 -19 -79 -33 -89 -18 -8 13 -96 -17 -96 -33 0 -19 -76 -45
-179 -61 -117 -18 -121 -18 -121 2 0 9 -6 14 -12 11 -7 -2 -12 -11 -10 -20 2
-12 -14 -25 -53 -43 -71 -34 -81 -48 -25 -39 33 6 41 4 38 -6 -5 -17 -85 -58
-114 -59 -11 0 -35 -11 -54 -25 -19 -14 -39 -25 -46 -25 -7 0 -45 -13 -85 -30
-41 -16 -77 -30 -81 -30 -19 0 -5 20 35 49 89 66 117 81 143 75 14 -4 24 -2
24 4 0 6 -17 13 -38 17 -33 5 -43 2 -69 -22 -17 -15 -59 -48 -93 -73 -35 -25
-81 -63 -104 -86 -23 -22 -53 -46 -68 -52 -25 -10 -39 -32 -20 -32 19 1 98 33
123 51 28 19 65 26 55 10 -4 -5 -36 -26 -73 -46 -95 -52 -181 -131 -189 -175
-5 -25 -27 -55 -78 -106 -39 -39 -79 -83 -89 -98 -10 -14 -24 -26 -32 -26 -8
0 -31 -35 -51 -78 -21 -46 -46 -82 -58 -88 -28 -12 -65 -71 -116 -184 -23 -52
-54 -106 -69 -121 -18 -17 -31 -44 -40 -85 -35 -156 -44 -190 -56 -204 -17
-21 -25 -68 -11 -73 8 -3 7 -12 -2 -31 -6 -15 -12 -37 -12 -49 0 -13 -6 -29
-12 -35 -11 -11 -35 -139 -41 -217 0 -11 -9 -28 -18 -38 -9 -10 -19 -39 -23
-65 -7 -53 -29 -92 -53 -92 -13 0 -14 10 -8 68 10 101 12 203 3 208 -4 3 -14
-9 -22 -25 -13 -24 -14 -39 -4 -86 8 -43 8 -64 -2 -94 -8 -27 -9 -44 -2 -57 6
-11 8 -30 6 -44 -2 -14 5 -43 15 -65 18 -37 20 -38 26 -17 4 12 11 22 16 22
12 0 22 -87 16 -142 -4 -27 -2 -70 3 -96 5 -26 10 -100 12 -165 2 -66 6 -121
10 -124 5 -2 8 -20 8 -39 0 -31 -3 -35 -20 -29 -17 5 -20 2 -20 -22 1 -27 20
-63 34 -63 3 0 6 11 6 25 0 14 5 25 11 25 13 0 37 -58 56 -135 9 -33 40 -116
71 -185 64 -147 70 -164 85 -250 10 -55 16 -67 40 -78 15 -7 27 -18 27 -24 0
-16 32 -37 57 -38 16 0 25 -10 34 -37 6 -21 18 -47 25 -58 8 -11 14 -31 14
-45 0 -14 9 -38 20 -55 11 -16 33 -50 50 -75 22 -33 28 -52 24 -73 -5 -23 1
-33 30 -61 32 -29 61 -77 93 -156 13 -31 61 -90 74 -90 17 0 9 20 -25 57 -35
40 -93 159 -83 170 4 3 22 -2 41 -11 19 -9 38 -16 43 -16 15 0 120 -59 133
-75 19 -23 4 -30 -24 -11 -28 18 -56 21 -56 6 0 -13 127 -140 140 -140 5 0 25
-14 45 -31 26 -23 34 -37 29 -51 -3 -10 0 -26 7 -35 16 -19 155 -122 175 -130
30 -11 12 15 -42 61 -30 27 -53 50 -50 53 9 9 145 -82 237 -158 38 -32 51 -37
94 -36 28 0 64 -7 80 -15 22 -12 34 -13 47 -5 12 8 21 7 32 -2 9 -7 14 -17 11
-21 -6 -9 50 -50 70 -50 8 0 15 -9 15 -20 0 -25 75 -67 83 -46 4 10 17 11 54
5 63 -10 83 -18 113 -44 24 -22 150 -70 150 -57 0 3 -10 17 -22 30 l-23 25 50
-7 c28 -4 102 -13 165 -21 63 -8 160 -27 215 -41 147 -39 145 -38 158 -21 9
13 35 17 117 19 58 1 111 -2 118 -6 8 -5 18 -2 25 6 22 27 93 38 260 42 125 4
173 8 196 21 40 20 43 50 4 40 -16 -4 -48 -9 -73 -11 -93 -9 0 29 125 51 21 4
80 26 130 50 93 44 193 79 258 90 20 3 37 10 37 15 0 5 35 40 79 77 74 64 148
103 196 103 21 0 129 60 121 67 -2 3 -21 0 -40 -7 -20 -6 -43 -10 -52 -8 -21
4 105 95 158 114 71 25 116 70 119 121 0 5 -10 10 -22 13 -21 5 -20 7 14 33
21 16 38 23 42 17 22 -35 213 164 292 304 39 69 50 82 59 73 4 -4 -9 -32 -30
-62 -39 -59 -28 -77 15 -22 37 47 94 155 86 163 -4 4 -18 2 -32 -4 -14 -7 -27
-8 -30 -2 -9 14 21 65 48 83 28 18 137 178 137 200 0 7 13 34 30 58 20 30 26
47 19 54 -7 7 -15 3 -24 -10 -19 -27 -58 -65 -63 -61 -8 9 20 87 33 92 13 5
54 83 70 133 9 30 -13 26 -25 -4 -10 -25 -30 -35 -30 -13 0 6 10 25 23 42 13
17 38 56 55 87 20 35 38 56 48 55 18 -1 44 68 44 117 0 15 7 44 15 64 8 20 13
39 10 42 -13 13 -40 -18 -43 -49 -2 -19 -13 -45 -24 -59 l-20 -26 5 35 c3 19
11 58 17 85 6 28 11 57 10 65 -4 88 -14 148 -27 162 -21 23 -9 78 18 78 12 0
21 10 26 28 14 47 7 223 -12 336 -13 81 -15 111 -7 114 14 4 16 37 3 60 -5 10
-12 69 -16 132 -5 85 -11 117 -21 123 -9 5 -12 16 -9 27 3 10 0 20 -9 23 -18
7 -26 -1 -26 -29 0 -20 -2 -21 -25 -11 -17 8 -23 18 -19 29 3 12 1 16 -8 13
-7 -2 -22 7 -32 22 -16 22 -17 30 -8 58 17 45 15 65 -9 105 -12 19 -28 57 -36
85 -8 27 -21 58 -28 68 -8 11 -11 33 -8 52 3 22 0 41 -11 56 -9 13 -16 28 -16
33 0 6 7 0 16 -12 8 -12 19 -22 25 -22 16 0 10 26 -12 46 -12 10 -36 42 -54
69 -17 28 -40 57 -51 65 -10 8 -16 11 -12 6 4 -5 3 -17 -3 -27 -7 -14 -6 -25
6 -41 16 -24 20 -48 7 -48 -4 0 -22 19 -40 42 -29 38 -31 45 -26 95 7 57 -4
83 -37 83 -11 0 -34 20 -55 50 -38 54 -56 64 -46 28 5 -20 4 -21 -11 -10 -9 8
-15 19 -14 25 1 6 -10 17 -24 24 -14 7 -39 31 -54 53 -15 22 -36 40 -46 40
-10 0 -21 5 -24 10 -4 6 -24 22 -46 36 -21 13 -39 30 -39 38 0 8 -22 36 -50
64 -27 28 -50 57 -50 65 0 7 -28 40 -62 72 -47 43 -64 54 -66 42 -2 -10 -6
-17 -8 -17 -11 0 -50 24 -77 46 -16 13 -37 24 -47 24 -9 0 -23 6 -29 14 -7 8
-24 17 -39 21 -15 3 -67 33 -115 66 -48 34 -114 69 -147 80 -32 11 -64 27 -71
35 -6 8 -22 14 -34 14 -13 0 -43 8 -67 18 -69 29 -153 45 -205 39 -50 -5 -101
9 -129 38 -16 16 -15 16 25 27 7 2 -5 10 -27 17 -23 8 -48 10 -59 6 -17 -8
-17 -8 2 -13 31 -6 42 -22 16 -22 -21 0 -22 -2 -10 -17 12 -15 12 -16 -4 -10
-10 4 -43 10 -73 13 -30 4 -54 11 -54 16 0 5 -13 14 -30 19 -16 6 -30 17 -30
25 0 10 -12 14 -38 14 -26 0 -45 7 -57 20 -21 23 -53 26 -80 6z m-871 -823 c6
-10 38 -76 72 -148 34 -71 87 -184 119 -250 31 -66 70 -147 85 -180 15 -33 58
-123 95 -200 37 -77 87 -183 112 -235 155 -332 318 -660 326 -657 6 2 40 68
77 147 37 80 83 180 103 223 21 43 37 80 37 81 0 2 29 64 64 137 35 74 75 160
90 192 l26 57 260 0 260 0 0 -1340 c0 -1318 0 -1340 -19 -1340 -15 0 -63 68
-190 273 l-171 273 0 747 c0 411 -4 747 -8 747 -5 0 -20 -26 -34 -57 -69 -152
-193 -423 -257 -562 -125 -267 -142 -304 -178 -386 -38 -87 -58 -115 -71 -100
-5 6 -42 82 -82 170 -68 150 -94 204 -207 445 -84 177 -170 365 -193 418 -12
28 -26 52 -31 52 -5 0 -9 -242 -9 -550 l0 -550 -192 2 -193 3 -3 1295 c-2
1225 -1 1296 15 1308 24 18 84 8 97 -15z m1633 -259 c67 -33 115 -87 142 -158
26 -71 27 -116 1 -186 -24 -67 -86 -132 -157 -165 -99 -47 -235 -24 -316 53
-84 79 -108 227 -53 332 38 74 49 85 119 120 51 25 72 30 137 30 62 0 86 -5
127 -26z m1632 -896 c1 -22 -4 -38 -10 -38 -7 0 -9 11 -5 31 3 17 2 39 -4 49
-5 9 -6 20 -2 24 10 10 20 -23 21 -66z m-4415 -2217 c26 -27 28 -51 5 -51 -14
0 -59 50 -59 66 0 23 25 16 54 -15z m286 -221 c0 -5 -4 -10 -10 -10 -5 0 -10
5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z"/>
<path d="M15427 20626 c-64 -27 -79 -36 -55 -36 26 0 139 46 132 53 -10 10
-12 9 -77 -17z"/>
<path d="M17275 20604 c28 -13 61 -23 75 -23 22 1 20 3 -15 19 -22 9 -56 20
-75 23 -33 5 -32 4 15 -19z"/>
<path d="M16990 20600 c0 -6 7 -10 15 -10 8 0 15 2 15 4 0 2 -7 6 -15 10 -8 3
-15 1 -15 -4z"/>
<path d="M18082 20144 c9 -9 21 -13 27 -9 16 10 3 25 -22 25 -20 0 -20 -1 -5
-16z"/>
<path d="M18173 20065 c27 -26 51 -44 54 -41 9 9 -30 48 -69 69 -30 17 -28 14
15 -28z"/>
<path d="M14525 20030 c-8 -13 5 -13 25 0 13 8 13 10 -2 10 -9 0 -20 -4 -23
-10z"/>
<path d="M18150 20016 c0 -14 61 -59 69 -50 6 5 -29 43 -51 55 -13 7 -18 6
-18 -5z"/>
<path d="M14180 19699 c0 -11 5 -17 10 -14 6 3 10 13 10 21 0 8 -4 14 -10 14
-5 0 -10 -9 -10 -21z"/>
<path d="M14184 19632 c-6 -4 -17 -19 -25 -33 -8 -15 -31 -56 -51 -90 -41 -71
-60 -127 -38 -114 8 5 11 3 8 -6 -3 -8 -10 -13 -17 -12 -14 4 -44 -43 -36 -57
9 -15 22 -4 50 41 26 41 30 50 18 48 -22 -4 -23 4 -2 39 13 20 39 56 58 79 19
23 36 50 37 60 1 10 5 26 9 36 8 19 6 21 -11 9z"/>
<path d="M13730 18815 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5
0 -10 -7 -10 -15z"/>
<path d="M19040 18311 c0 -23 5 -41 10 -41 6 0 10 15 10 34 0 19 -4 38 -10 41
-6 4 -10 -10 -10 -34z"/>
<path d="M19050 18095 c0 -15 4 -24 10 -20 6 3 10 12 10 20 0 8 -4 17 -10 20
-6 4 -10 -5 -10 -20z"/>
<path d="M13715 17886 c-5 -10 -3 -32 3 -50 7 -18 12 -42 12 -54 0 -35 20
-119 34 -137 20 -27 12 77 -8 106 -9 13 -16 42 -17 64 -1 22 -4 51 -9 65 -7
23 -8 23 -15 6z"/>
<path d="M13690 17621 c0 -6 5 -13 10 -16 6 -3 10 1 10 9 0 9 -4 16 -10 16 -5
0 -10 -4 -10 -9z"/>
<path d="M18936 17428 c-18 -36 -20 -54 -6 -63 10 -6 24 21 36 70 9 36 -12 31
-30 -7z"/>
<path d="M13870 17073 c0 -12 5 -25 10 -28 13 -8 13 15 0 35 -8 12 -10 11 -10
-7z"/>
<path d="M13910 16981 c0 -6 5 -13 10 -16 6 -3 10 1 10 9 0 9 -4 16 -10 16 -5
0 -10 -4 -10 -9z"/>
<path d="M18585 16700 c-10 -11 -16 -22 -13 -25 3 -3 13 4 23 15 10 11 16 22
13 25 -3 3 -13 -4 -23 -15z"/>
<path d="M18465 16500 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M18360 16430 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5
0 -10 -4 -10 -10z"/>
<path d="M14331 16406 c7 -14 19 -26 27 -26 13 0 13 3 0 22 -22 33 -41 36 -27
4z"/>
<path d="M18355 16360 c-10 -11 -14 -20 -8 -20 5 0 18 9 28 20 10 11 14 20 8
20 -5 0 -18 -9 -28 -20z"/>
<path d="M18248 16267 c-18 -7 -28 -18 -28 -31 0 -11 -7 -28 -17 -38 -33 -36
8 -17 47 22 55 55 54 69 -2 47z"/>
<path d="M18132 16219 c-23 -17 -42 -37 -42 -45 0 -19 13 -18 54 7 25 15 36
28 36 45 0 13 -1 24 -3 24 -2 0 -22 -14 -45 -31z"/>
<path d="M14580 16131 c0 -11 42 -43 48 -37 2 2 -3 13 -10 25 -13 21 -38 29
-38 12z"/>
<path d="M17537 15744 c-16 -9 -27 -17 -25 -20 7 -7 68 17 68 27 0 12 -10 11
-43 -7z"/>
<path d="M17350 15680 c0 -5 4 -10 9 -10 6 0 13 5 16 10 3 6 -1 10 -9 10 -9 0
-16 -4 -16 -10z"/>
<path d="M17075 15610 c-3 -5 3 -10 14 -10 11 0 23 5 26 10 3 6 -3 10 -14 10
-11 0 -23 -4 -26 -10z"/>
<path d="M15574 15585 c22 -17 36 -19 36 -6 0 10 -24 21 -43 21 -7 0 -3 -7 7
-15z"/>
<path d="M15966 15541 c12 -11 116 -41 144 -41 40 0 19 34 -25 42 -58 10 -131
10 -119 -1z"/>
<path d="M16745 15540 c-3 -5 3 -10 15 -10 12 0 18 5 15 10 -3 6 -10 10 -15
10 -5 0 -12 -4 -15 -10z"/>
<path d="M13634 13575 c-117 -25 -189 -76 -235 -165 -19 -37 -23 -61 -24 -130
0 -169 63 -236 312 -325 154 -56 185 -84 169 -151 -19 -73 -188 -71 -331 5
-27 14 -53 27 -57 29 -4 2 -30 -42 -58 -98 l-51 -101 74 -35 c143 -67 323 -81
471 -34 94 30 167 100 192 186 32 113 -3 254 -82 323 -45 40 -108 71 -214 106
-47 15 -102 36 -122 46 -64 33 -76 85 -27 122 64 47 193 27 271 -43 l46 -40
68 87 68 86 -40 33 c-116 98 -271 134 -430 99z"/>
<path d="M14608 13574 c-162 -39 -255 -127 -315 -301 -24 -69 -27 -93 -27
-208 0 -183 33 -286 127 -391 99 -109 266 -157 429 -123 156 33 262 138 324
319 26 78 26 289 0 380 -29 98 -63 159 -122 216 -108 105 -262 146 -416 108z
m183 -217 c84 -56 124 -170 117 -329 -4 -86 -9 -106 -39 -165 -45 -90 -83
-116 -160 -111 -71 5 -110 32 -143 101 -66 135 -58 342 18 458 46 68 142 90
207 46z"/>
<path d="M11636 13473 c-3 -54 -13 -242 -21 -418 -8 -176 -17 -359 -21 -407
l-6 -88 125 0 125 0 6 113 c3 61 9 186 14 277 l7 165 95 -280 95 -280 95 0 94
0 80 272 c44 149 83 270 86 268 4 -2 13 -124 20 -270 l13 -265 118 0 119 0 0
28 c0 15 -11 223 -25 462 -14 239 -25 454 -25 478 l0 42 -142 0 -143 0 -100
-335 c-55 -184 -102 -329 -106 -322 -4 6 -53 157 -110 335 l-103 322 -142 0
-142 0 -6 -97z"/>
<path d="M12920 13065 l0 -505 130 0 130 0 0 505 0 505 -130 0 -130 0 0 -505z"/>
<path d="M15380 13065 l0 -505 340 0 340 0 0 105 0 105 -210 0 -210 0 0 400 0
400 -130 0 -130 0 0 -505z"/>
<path d="M16510 13548 c-19 -44 -350 -971 -350 -979 0 -5 58 -9 129 -9 l129 0
33 85 32 85 160 -2 160 -3 30 -82 30 -83 134 0 c125 0 135 1 128 18 -3 9 -82
229 -175 487 -93 259 -172 478 -175 488 -6 15 -22 17 -131 17 -120 0 -125 -1
-134 -22z m184 -439 c25 -86 46 -159 46 -163 0 -3 -45 -6 -101 -6 -91 0 -100
2 -95 18 3 9 24 78 46 152 46 155 49 164 54 159 2 -2 24 -74 50 -160z"/>
<path d="M17280 13065 l0 -507 228 4 c215 4 231 6 295 30 119 45 183 102 238
210 75 148 78 371 8 511 -58 116 -130 181 -246 225 -64 24 -81 26 -295 30
l-228 4 0 -507z m448 258 c69 -42 103 -114 109 -230 6 -105 -11 -177 -56 -239
-37 -52 -90 -77 -173 -82 l-68 -4 0 297 0 298 70 -5 c55 -4 81 -12 118 -35z"/>
<path d="M18550 13548 c-19 -44 -350 -971 -350 -980 0 -5 58 -7 131 -6 l131 3
30 83 30 82 160 -2 161 -3 30 -82 30 -83 134 0 c125 0 135 1 128 18 -3 9 -82
229 -175 487 -93 259 -172 478 -175 488 -6 15 -22 17 -131 17 -119 0 -125 -1
-134 -22z m184 -439 c25 -86 46 -159 46 -163 0 -3 -45 -6 -101 -6 -84 0 -100
2 -96 15 4 8 25 78 48 157 41 140 48 163 54 156 1 -2 23 -73 49 -159z"/>
<path d="M19240 13465 l0 -105 130 0 130 0 0 -400 0 -400 130 0 130 0 0 400 0
400 130 0 130 0 0 105 0 105 -390 0 -390 0 0 -105z"/>
<path d="M20449 13543 c-35 -90 -349 -968 -349 -975 0 -5 59 -7 131 -6 l131 3
30 83 30 82 160 -2 161 -3 30 -82 30 -83 134 0 c125 0 135 1 128 18 -3 9 -82
229 -175 487 -93 259 -172 478 -175 488 -6 15 -22 17 -131 17 l-124 0 -11 -27z
m185 -434 c25 -86 46 -159 46 -163 0 -3 -45 -6 -101 -6 -84 0 -100 2 -96 15 4
8 25 78 48 157 41 140 48 163 54 156 1 -2 23 -73 49 -159z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
